export default __webpack_public_path__ + "static/media/t7.411fe42e.jpg";